const t = "light", e = "dark", s = "green", o = "grey", n = "dark-grey", r = "custom", c = {
  props: {
    /**
         * Component's theme
         * Possible values are: 'light', 'dark', 'green', 'grey', 'dark-grey'.
         */
    theme: {
      type: String,
      default: t,
      validator: (E) => [t, e, s, o, n, r].includes(E)
    },
    customTheme: {
      type: String,
      default: null
    }
  },
  created() {
    this.$options.theme = {
      light: t,
      dark: e,
      green: s,
      grey: o,
      "dark-grey": n,
      custom: r
    }, this.$options.customTheme = null;
  }
};
export {
  c as default
};
